import module from 'recursoshumanos/module.js'
import template from './template.html'

export  class RecursoshumanosPagosSuaListaAgrupacionComponent {
  empresa
  data
  onSelect

  $onChanges (changes) {
    if (changes.data) {
      this.totalizar()
    }
  }

  seleccionar (item) {
    this.onSelect({
      $event: {
        items: [item],
        seleccionado: !item.seleccionado,
      },
    })
  }

  seleccionarToggle () {
    this.onSelect({
      $event: {
        items: this.data,
        seleccionado: !this.todosSeleccionados,
      },
    })
  }

  totalizar () {
    this.todosSeleccionados = this.data.every((item) => item.seleccionado)
  }
}

module.component('recursoshumanosPagosSuaListaAgrupacion', {
  controller: RecursoshumanosPagosSuaListaAgrupacionComponent,
  template,
  bindings: {
    data: '<',
    bimestral: '<',
    indicador: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/lista/agrupacion/component.js